import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Calendar,
  Users,
  Settings,
  Printer,
  BarChart3,
  FileText,
  UserCog,
  UserCheck,
  X,
  Cog,
  Palette,
  // Mail,
} from 'lucide-react';
import { cn } from '../../utils/cn';
import { useEffectiveAuth } from '../../hooks/useEffectiveAuth';

const Sidebar = ({ isOpen, onClose }) => {
  const { effectiveUser, effectivePermissions } = useEffectiveAuth();
  
  // Get navigation items based on user permissions
  const getNavigationItems = () => {
    const items = [
      { 
        to: '/dashboard', 
        icon: LayoutDashboard, 
        label: 'Dashboard',
        show: true // Everyone can see dashboard
      }
    ];

    // User Management - only for users who can create users
    if (effectivePermissions.canCreateUsers()) {
      items.push({
        to: '/users', 
        icon: UserCog, 
        label: 'User Management',
        show: true
      });
    }

    // Events - for admins and event admins
    if (effectivePermissions.canCreateEvents() || effectivePermissions.canSeeAllEvents()) {
      items.push({
        to: '/events', 
        icon: Calendar, 
        label: 'Events',
        show: true
      });
    }

    // Attendees - for all staff roles
    if (effectiveUser?.role !== 'attendee') {
      items.push({
        to: '/attendees', 
        icon: Users, 
        label: 'Attendees',
        show: true
      });
    }

    // Check-In Station - for all staff roles
    if (effectiveUser?.role !== 'attendee') {
      items.push({
        to: '/check-in', 
        icon: UserCheck, 
        label: 'Check-In Station',
        show: true
      });
    }
// Print Station - for all staff roles
if (effectiveUser?.role !== 'attendee') {
  items.push({
    to: '/print-station', 
    icon: Printer, 
    label: 'Print Station',
    show: true
  });
}
    // Custom Fields - for admins
    if (effectivePermissions.isAdmin()) {
      items.push({
        to: '/custom-fields', 
        icon: Settings, 
        label: 'Custom Fields',
        show: true
      });
    }

    // Badge Templates - for admins
    if (effectivePermissions.isAdmin()) {
      items.push({
        to: '/badges', 
        icon: FileText, 
        label: 'Badge Templates',
        show: true
      });
    }

    // Sticker Templates - for admins
    if (effectivePermissions.isAdmin()) {
      items.push({
        to: '/stickers', 
        icon: Palette, 
        label: 'Sticker Templates',
        show: true
      });
    }

    // Email Campaigns - for admins
    // if (effectivePermissions.isAdmin()) {
    //   items.push({
    //     to: '/email-campaigns', 
    //     icon: Mail, 
    //     label: 'Email Campaigns',
    //     show: true
    //   });
    // }

  

    // Analytics - for admins
    if (effectivePermissions.isAdmin()) {
      items.push({
        to: '/analytics', 
        icon: BarChart3, 
        label: 'Analytics',
        show: true
      });
    }

    // System Settings - for super admins only
    if (effectivePermissions.isSuperAdmin()) {
      items.push({
        to: '/system-settings', 
        icon: Cog, 
        label: 'System Settings',
        show: true
      });
    }

    return items.filter(item => item.show);
  };

  const navItems = getNavigationItems();

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          'fixed md:sticky top-0 left-0 z-50 w-64 bg-white border-r border-gray-200 h-screen transition-transform duration-300 ease-in-out',
          isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
        )}
      >
        {/* Mobile close button */}
        <div className="md:hidden flex justify-end p-4">
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <X className="h-6 w-6 text-gray-600" />
          </button>
        </div>

        <nav className="p-4 space-y-1 overflow-y-auto h-full pb-20">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => onClose()}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 px-4 py-3 rounded-lg transition-colors',
                  isActive
                    ? 'bg-primary-50 text-primary-700 font-medium'
                    : 'text-gray-700 hover:bg-gray-100'
                )
              }
            >
              <item.icon className="h-5 w-5" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
